(function($){
  $(document).ready(function() {


    /*
    * Responsive JS
    * http://www.javascriptkit.com/javatutors/matchmediamultiple.shtml
    */
    const tab = 768,
        ordi = 980,
        mqMobile   = 'only screen and (max-width: ' + (tab-1) + 'px)',
        mqTablette = 'only screen and (max-width: ' + (ordi-1) + 'px) and (min-width: ' + tab + 'px)',
        mqOrdi     = 'only screen and (min-width: ' + ordi + 'px)',
        mqlist = [
            window.matchMedia(mqMobile),
            window.matchMedia(mqTablette),
            window.matchMedia(mqOrdi)
    ];

    const navpages = $('.nav-pages');

    const menu = $('#menu');
    const nav1 = $('.nav1');
    const nav2 = $('.nav2');
    const recherche = $('#recherche');
    const formchercher = $('#formchercher');

    const outils = $('.menu-outils');
    const outilssticky = outils.stickybits({
        useStickyClasses: true,
        stickyBitStickyOffset: 80
    });

    function mediaqueryresponse(mql){
        const regexp_mobile   = new RegExp('\\(max-width:\\s*' + (tab-1) + 'px\\)'),
              regexp_tablette = new RegExp('\\(max-width:\\s*' + (ordi-1) + 'px\\) and \\(min-width:\\s*' + tab + 'px\\)'),
              regexp_ordi     = new RegExp('\\(min-width:\\s*' + (ordi) + 'px\\)');

        if (regexp_mobile.test(mql.media)){
            if (mql.matches){
                $('.site-header').after(menu);
                formchercher.prependTo(recherche);
                nav2.appendTo(menu);
                recherche.appendTo(menu);
                $('.nav-ariane').before(navpages);
            }
            else{
            }
        }
        else if (regexp_tablette.test(mql.media)){
            if (mql.matches){
                $('.site-header').after(menu);
                formchercher.prependTo(recherche);
                nav2.appendTo(menu);
                recherche.appendTo(menu);
                navpages.prependTo($('.col-infos-container'));
            }
            else{
            }
        }
        else if (regexp_ordi.test(mql.media)){
            if (mql.matches){
                menu.appendTo($('.header-container'));
                $('.nav-header').after(nav2);
                recherche.prependTo(nav2);
                navpages.prependTo($('.col-infos-container'));
                formchercher.appendTo($('body'));
                // outilssticky.update();
            }
            else{
            }
        }
    }

    for (var i=0; i<mqlist.length; i++){
        mediaqueryresponse(mqlist[i]);
        mqlist[i].addListener(mediaqueryresponse);
    }

  })
})(jQuery);
